import { logInfo } from 'setup/logger/logInfo';
import { getServiceWorkerContainer } from './serviceWorkerContainer';
import { ServiceWorkerUpdateResult } from './serviceWorkerUpdateResult';

let isUpdateRequested = false;

/**
 * Asks the browser to fetch the worker script now. A newer worker ends up
 * `waiting`, and `useRegisterSW` (WithServiceWorkerStatusCheck) offers the
 * update banner.
 */
export async function checkForServiceWorkerUpdate(reason: string): Promise<ServiceWorkerUpdateResult> {
  const container = getServiceWorkerContainer();
  if (!container) {
    return ServiceWorkerUpdateResult.noWorker;
  }
  logInfo('service-worker-update-requested', { reason });
  try {
    const registration = await container.getRegistration();
    if (!registration) {
      return ServiceWorkerUpdateResult.noWorker;
    }
    await registration.update();
    return registration.waiting ?? registration.installing
      ? ServiceWorkerUpdateResult.started
      : ServiceWorkerUpdateResult.notStarted;
  } catch (error: unknown) {
    logInfo('service-worker-update-failed', { reason, error });
    return ServiceWorkerUpdateResult.notStarted;
  }
}

/** Checks for a newer worker once per page load, whatever failure asks for it. */
export function requestServiceWorkerUpdate(reason: string): void {
  if (isUpdateRequested) {
    return;
  }
  isUpdateRequested = true;
  void checkForServiceWorkerUpdate(reason);
}
